// extracted by mini-css-extract-plugin
export default {"editable":"TextAreaEditable--editable--jXLcq"};